module.exports = __webpack_public_path__ + "img/calendar.ec70be19.svg";